import React from 'react';
import {useSelector} from 'react-redux';
import { getAllMovies,getAllShows } from '../../features/movies/movieSlice';
import MovieCard from '../MovieCard/MovieCard';
import './MovieListing.scss';
import Slider from "react-slick";
import { Settings } from '../../common/Setting';

const MovieListing = () => {

    const movies=useSelector(getAllMovies);
    const shows=useSelector(getAllShows);

    let renderMovies=movies.Response === "True" ?    //ternary operator
    (movies.Search.map((movie,index)=>{
       return <MovieCard key={index} data={movie}/>
    })):
    (<div className="movies-error"><h3>{movies.Error}</h3></div>);

    let renderShows=shows.Response === "True" ?    //ternary operator
    (shows.Search.map((movie,index)=>{
       return <MovieCard key={index} data={movie}/>
    })):
    (<div className="shows-error"><h3>{shows.Error}</h3></div>);
    
    return (
        <div className="movie-wrapper">
            <div className="movie-list">
                <h2>Movies</h2>
                <div className="movie-container">
                    
                    <Slider {...Settings}>{renderMovies}</Slider></div>
            </div>
            <div className="show-list">
                <h2>Shows</h2>
                <div className="movie-container">
                <Slider {...Settings}>{renderShows}</Slider></div>
            </div>
        </div>
    );
};

export default MovieListing;